@if (appFooterContainerCSSClass) {
<!--begin::Footer container-->
<div class="app-container" [ngClass]="appFooterContainerCSSClass">
  <ng-container *ngTemplateOutlet="footerView"></ng-container>
</div>
<!--end::Footer container-->
} @if (!appFooterContainerCSSClass) {
<ng-container *ngTemplateOutlet="footerView"></ng-container>
}

<!--
  The footer used to be a logo alone on a dark band: the last thing on every
  page was an empty room. It is now the third ink panel of the site rather than
  a full stop — brand and what this is on the left, the two short link columns
  a visitor actually wants at the bottom of a page, and the demo disclaimer
  where it can be read rather than only in the ribbon at the top.
-->
<ng-template #footerView>
  <section class="site-footer d-flex flex-column w-100">
    @if (displaySection != 'copyright') {

    <div class="row site-footer__top g-8 g-lg-10">
      <!-- Brand column. Wider than the link columns: it carries the sentence
           that says what the product is, which is the one thing a visitor who
           scrolled this far may still not know. -->
      <div class="col-12 col-lg-5">
        <app-brand-logo [light]="darkFooter" size="lg"></app-brand-logo>
        <p class="site-footer__blurb mt-5 mb-0">
          {{ "FOOTER.BLURB" | translate }}
        </p>
      </div>

      <div class="col-6 col-lg-2 offset-lg-1">
        <p class="site-footer__head">{{ "FOOTER.EXPLORE" | translate }}</p>
        <ul class="site-footer__list">
          @for (item of exploreLinks; track item.route) {
          <li>
            <a [routerLink]="item.route">{{ item.label | translate }}</a>
          </li>
          }
        </ul>
      </div>

      <div class="col-6 col-lg-2">
        <p class="site-footer__head">{{ "FOOTER.COMPANY" | translate }}</p>
        <ul class="site-footer__list">
          @for (item of companyLinks; track item.route) {
          <li>
            <a [routerLink]="item.route">{{ item.label | translate }}</a>
          </li>
          }
        </ul>
      </div>

      <div class="col-12 col-lg-2">
        <p class="site-footer__head">{{ "FOOTER.CONTACT" | translate }}</p>
        <ul class="site-footer__list site-footer__list--plain">
          <li>{{ contact.address }}</li>
          <li>{{ contact.tel }}</li>
          <li>{{ contact.email }}</li>
        </ul>

        <!-- Hidden when there is nothing to link to. The demo has no social
             accounts of its own, and a "Social Media" heading over empty space
             looks like a page that failed to load. -->
        @if (hasSocials) {
        <div class="d-flex flex-wrap gap-3 mt-4">
          @for (item of socials; track item.name) {
          <a
            class="site-footer__social"
            [attr.href]="item.url"
            target="_blank"
            rel="noopener"
            [attr.aria-label]="item.name"
          >
            @if (item.icon) {
            <app-icon-svg [icon]="item.icon!" classes="icon-lg"></app-icon-svg>
            } @else { {{ item.name }} }
          </a>
          }
        </div>
        }
      </div>
    </div>

    }

    <div class="site-footer__rule"></div>

    <div class="site-footer__bottom">
      <ul class="site-footer__legal">
        @for (item of legalLinks; track item.route) {
        <li>
          <a [routerLink]="item.route">{{ item.label | translate }}</a>
        </li>
        }
      </ul>

      <div class="site-footer__meta">
        @if (demo.enabled) {
        <span class="site-footer__note">{{ "FOOTER.DEMO_NOTE" | translate }}</span>
        }
        <span class="site-footer__copy">
          © {{ currentDateStr }} Wise · {{ "FOOTER.RIGHTS" | translate }} · Powered by
          Riseplus Technology Co., Ltd.
        </span>
      </div>
    </div>
  </section>
</ng-template>
